module.exports = __webpack_public_path__ + "static/img/img-1.a07a87ab.jpeg";